import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Button from '../../Button/Button';
import './LandingCTA.css';

gsap.registerPlugin(ScrollTrigger);

const LandingCTA = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (sectionRef.current && containerRef.current) {
      const randomRotation = gsap.utils.random(-3, 3);

      const entranceAnimation = gsap.fromTo(containerRef.current, 
        { yPercent: 10, rotationZ: randomRotation }, 
        { yPercent: 0, rotationZ: 0, ease: "power1.inOut" }
      );

      const entranceTrigger = ScrollTrigger.create({
        trigger: sectionRef.current,
        start: "top bottom",
        end: "center center",
        animation: entranceAnimation,
        scrub: 0.5,
      });

      const fadeOutAnimation = gsap.to(containerRef.current, 
        { opacity: 0, ease: "power1.inOut" }
      );

      const fadeOutTrigger = ScrollTrigger.create({
        trigger: sectionRef.current,
        start: "center center", 
        end: "bottom top",
        animation: fadeOutAnimation,
        scrub: 0.5,
      });

      return () => {
        if (entranceTrigger) entranceTrigger.kill();
        if (fadeOutTrigger) fadeOutTrigger.kill();
      };
    }
  }, []);

  return (
    <section 
      id="pricing" 
      ref={sectionRef}
      className="landing-cta-section"
    >
      <div 
        ref={containerRef}
        className="landing-cta-container"
      >
        <h2 className="landing-cta-title">
          Better Writing <br />
          Faster Translation <br />
          Smooth Workflow
        </h2>
        <div className="cta-actions-row">
          <p className="landing-cta-subtitle">
            Get all three with Texta <br/>$5/seat/month
          </p>
          <Link to="/signup" className="landing-cta-link">
            <Button variant="primary" size="xlarge">
              Get started now
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LandingCTA; 